import ControlHider from 'leaflet-control-hider'

import 'leaflet-control-hider/src/hider.css'

export default ControlHider
